module.exports = __webpack_public_path__ + "static/social_ads-db05883d94785af67d03952831ee5bc7.svg";